import system from '@teacher/views/system/popup';
import home from '@teacher/views/home/popup';
import frontdesk from '@teacher/views/frontdesk/popup';
import finance from '@teacher/views/finance/popup';
import teaching from '@teacher/views/teaching/popup';
import common from '@teacher/views/common/popup';
import datacenter from '@teacher/views/datacenter/popup';
import jiaowu from '@teacher/views/jiaowu/popup';
import storedCard from '@teacher/views/stored-card/popup';

export default [
  ...system,
  ...home,
  ...frontdesk,
  ...finance,
  ...teaching,
  ...common,
  ...datacenter,
  ...jiaowu,
  ...storedCard,
  {
    name: 'class-chooser',
    component: () => import(/* webpackChunkName: "class-chooser" */ './class-chooser/class-chooser.vue'),
  },
  {
    name: 'multiple-class-chooser',
    component: () => import(
      /* webpackChunkName: "multiple-class-chooser" */ './class-chooser/multiple-class-chooser.vue'
    ),
  },
  {
    name: 'multiple-material-chooser',
    component: () => import(
      /* webpackChunkName: "multiple-material-chooser" */ './material-chooser/multiple-chooser.vue'
    ),
  },
  {
    name: 'order-chooser',
    component: () => import(/* webpackChunkName: "order-chooser" */ './order-chooser/order-chooser.vue'),
  },
  {
    name: 'refund-order-chooser',
    component: () => import(
      /* webpackChunkName: "refund-order-chooser" */ './refund-order-chooser/refund-order-chooser.vue'
    ),
  },
  {
    name: 'refund-order-multi-chooser',
    component: () => import(
      /* webpackChunkName: "refund-order-multi-chooser" */ './refund-order-chooser/refund-order-multi-chooser.vue'
    ),
  },
  {
    name: 'refund-material-multi-chooser',
    component: () => import(
      /* webpackChunkName: "refund-material-multi-chooser" */ './refund-order-chooser/refund-material-multi-chooser.vue'
    ),
  },
  {
    name: 'company-change',
    component: () => import(/* webpackChunkName: "company-change" */ './company-change/company-change.vue'),
  },
  {
    name: 'base-price-dimension',
    component: () => import(
      /* webpackChunkName: "base-price-dimension" */ './base-price-dimension/base-price-dimension.vue'
    ),
  },
  {
    name: 'curriculumId-student-chooser',
    component: () => import(/* webpackChunkName: "curriculumId-student-chooser" */ './student-chooser/curriculumId-student-chooser.vue'),
  },
  {
    name: 'cropper',
    component: () => import(/* webpackChunkName: "cropper" */ './cropper/cropper.vue'),
  },
  {
    name: 'column-chooser',
    component: () => import(/* webpackChunkName: "column-chooser" */ './column-chooser/column-chooser.vue'),
  },
  {
    name: 'student-chooser',
    component: () => import(/* webpackChunkName: "student-chooser" */ './student-chooser/student-chooser.vue'),
  },
  {
    name: 'base-student-chooser',
    component: () => import(/* webpackChunkName: "base-student-chooser" */ './student-chooser/base-student-chooser.vue'),
  },
  {
    name: 'location-chooser',
    component: () => import(/* webpackChunkName: "location-chooser" */ './location-chooser/location-chooser.vue'),
  },
  {
    name: 'base-curriculum-chooser',
    component: () => import(/* webpackChunkName: "base-curriculum-chooser" */ './curriculum-chooser/base-curriculum-chooser.vue'),
  },
  {
    name: 'project-fee-curriculum-chooser',
    component: () => import(/* webpackChunkName: "project-fee--curriculum-chooser" */ './curriculum-chooser/project-fee-curriculum-chooser.vue'),
  },
  {
    name: 'sys-authorization',
    component: () => import(/* webpackChunkName: "sys-authorization" */ './sys-authorization/auth.vue'),
  },
  // 上课点名
  {
    name: 'course-attend',
    component: () => import(/* webpackChunkName: "course-attend" */ './course-attend/course-attend.vue'),
  },
  // 欠费课消提示
  {
    name: 'owe-cost-confirm',
    component: () => import(/* webpackChunkName: "owe-cost-confirm" */ './course-attend/owe-cost-confirm.vue'),
  },
  // 支付信息弹窗
  {
    name: 'sf-popup',
    component: () => import(/* webpackChunkName: "sf-popup" */ './sf-pay/sf-popup.vue'),
  },
  // 支付弹窗
  {
    name: 'sf-pay-popup',
    component: () => import(/* webpackChunkName: "sf-pay-popup" */ './sf-pay/sf-pay-popup.vue'),
  },
  // 支付-储值卡代付弹窗
  {
    name: 'sf-stored-card-verify-popup',
    component: () => import(/* webpackChunkName: "sf-stored-card-verify-popup" */ './sf-pay/sf-stored-card-verify-popup.vue'),
  },
  // 支付-分摊明细弹窗
  {
    name: 'sf-divide-popup',
    component: () => import(/* webpackChunkName: "sf-divide-popup" */ './sf-pay/sf-divide-popup.vue'),
  },
];
